import { EMAIL_REGEX, MAX_INPUT_LENGTH } from "./constants";
import {
  apiRequest,
  formatApiRequestError,
  validatePassword,
  validatePhoneNumberForCountry,
} from "./helpers";

const validateEmailHelper = (value: string) => {
  return new Promise(function (resolve) {
    const email = {
      value: value,
      error: false,
      helperText: "",
    };
    if (value) {
      if (value.length > 0 && !EMAIL_REGEX.exec(value)) {
        email.error = true;
        email.helperText = "Invalid email";
      }
      if (value.length > MAX_INPUT_LENGTH) {
        email.error = true;
        email.helperText = "Invalid email: too long";
      }
    }
    resolve(email);
  });
};

const validatePasswordHelper = (value: string) => {
  let password = {
    value: "",
    error: false,
    helperText: "",
  };
  if (value.length > MAX_INPUT_LENGTH) {
    password.error = true;
    password.helperText = "Invalid password: too long";
  } else if (value.length > 0) {
    const isPasswordValid = validatePassword(value).isValid;
    password = {
      value: value,
      error: !isPasswordValid,
      helperText: isPasswordValid ? "" : "Invalid password",
    };
  }
  return password;
};

const validateSignupEmailHelper = (value: string) => {
  return new Promise(function (resolve, reject) {
    const email = {
      value: value,
      error: false,
      helperText: "",
    };
    if (value) {
      if (value.length > 0 && !EMAIL_REGEX.exec(value)) {
        email.error = true;
        email.helperText = "Invalid email";
      }
      if (value.length > MAX_INPUT_LENGTH) {
        email.error = true;
        email.helperText = "Invalid email: too long";
      }
      if (!email.error) {
        apiRequest({
          method: "GET",
          endpoint: "verify-email-phone",
          params: { email: email.value },
        })
          .then((data: any) => {
            if (!data.emailAvailable) {
              email.error = true;
              email.helperText = "Email already in use";
            }
            resolve(email);
          })
          .catch((error) => {
            console.warn(
              "Could not fetch email use status:",
              formatApiRequestError(error)
            );
            email.error = true;
            email.helperText = "error";
            resolve(email);
          });
      } else {
        resolve(email);
      }
    } else {
      resolve(email);
    }
  });
};

const validateSignupPhoneNumberHelper = (
  value: string,
  country: string | undefined,
  checkDuplicate: boolean
) => {
  return new Promise(function (resolve, reject) {
    const phoneNumber = {
      value: value,
      error: false,
      helperText: "",
    };
    if (value) {
      const number = validatePhoneNumberForCountry(value, country);
      if (number.isValid) {
        phoneNumber.value = number.value;
      } else {
        phoneNumber.error = true;
        phoneNumber.helperText = "Invalid number for selected country";
      }
      if (!phoneNumber.error && checkDuplicate) {
        apiRequest({
          method: "GET",
          endpoint: "verify-email-phone",
          params: { phoneNumber: phoneNumber.value },
        })
          .then((data: any) => {
            if (!data.phoneNumberAvailable) {
              phoneNumber.error = true;
              phoneNumber.helperText = "Phone number already in use";
            }
            resolve(phoneNumber);
          })
          .catch((error) => {
            console.warn(
              "Could not fetch phone number uniqueness status:",
              formatApiRequestError(error)
            );
            phoneNumber.error = true;
            phoneNumber.helperText = "error";
            resolve(phoneNumber);
          });
      } else {
        resolve(phoneNumber);
      }
    } else {
      resolve(phoneNumber);
    }
  });
};

const validateUserPasswordHelper = (value: string, companyId: number) => {
  return new Promise(function (resolve, reject) {
    const currentPassword = {
      value: value,
      error: false,
      helperText: "",
    };
    if (value) {
      apiRequest({
        method: "POST",
        endpoint: `v2/companies/${companyId}/users/validate-password`,
        body: { currentPassword: value },
      })
        .then(() => resolve(currentPassword))
        .catch((error) => {
          currentPassword.error = true;
          currentPassword.helperText = "Wrong Password. Please try again.";

          console.warn(
            "Could not validate the current user pasword:",
            formatApiRequestError(error)
          );
          resolve(currentPassword);
        });
    } else {
      resolve(currentPassword);
    }
  });
};

const validateTextHelper = (name: string, value: string) => {
  const formField = {
    value: value.trim(),
    error: false,
    helperText: "",
  };
  // only white spaces
  if (value.length > 0 && formField.value.length === 0) {
    formField.error = true;
  }
  // text too long for database
  // utf-8 may use up to three bytes per character
  // inputs more than 85 characters long may get truncated in vachar(255) column
  if (value.length > MAX_INPUT_LENGTH) {
    formField.error = true;
    switch (name) {
      case "firstName":
        formField.helperText = "First name";
        break;
      case "lastName":
        formField.helperText = "Last name";
        break;
      case "companyName":
        formField.helperText = "Company name";
        break;
      default:
        formField.helperText = "Text";
    }
    formField.helperText += " too long";
  }
  return formField;
};

export {
  validateEmailHelper,
  validatePasswordHelper,
  validateSignupEmailHelper,
  validateSignupPhoneNumberHelper,
  validateTextHelper,
  validateUserPasswordHelper,
};
